var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-image',{staticStyle:{"width":"100px","height":"100px","object-fit":"cover"},attrs:{"src":_vm.useResize ? `${_vm.cover}?x-oss-process=image/resize,w_120` : _vm.cover,"fit":"fill","preview-src-list":[_vm.cover]},on:{"error":_vm.onError}})
}
var staticRenderFns = []

export { render, staticRenderFns }